import {
    AfterViewInit,
    Component,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { ButtonComponent } from '@bilancio/ui';
import { TourTemplateService } from './tour-template.service';

@Component({
    selector: 'app-tour-template-component',
    templateUrl: './tour-template.component.html',
    styleUrls: ['./tour-template.component.scss'],
    imports: [ButtonComponent]
})
export class TourTemplateComponent implements AfterViewInit {
    @ViewChild('prevButton') prevButton: TemplateRef<any>;
    @ViewChild('nextButton') nextButton: TemplateRef<any>;
    @ViewChild('doneButton') doneButton: TemplateRef<any>;
    @ViewChild('counter') counter: TemplateRef<any>;
    @ViewChild('customContent') customContent: TemplateRef<any>;

    constructor(readonly tourTemplateService: TourTemplateService) {}

    ngAfterViewInit() {
        this.tourTemplateService.prevButton = this.prevButton;
        this.tourTemplateService.nextButton = this.nextButton;
        this.tourTemplateService.doneButton = this.doneButton;
        this.tourTemplateService.counter = this.counter;
        this.tourTemplateService.customContent = this.customContent;
    }
}
